import React, { Component } from "react";
import { connect } from "react-redux";
import $ from "jquery";
import Nav from "./Nav";
import axios from "axios";
import PageTransition from "./PageTransition";
import { fetchSingleStock } from "../actions/authActions";
import {
  FaSearch,
  FaSortDown,
  FaDollarSign,
  FaHammer,
  FaExclamationTriangle,
  FaTimes,
} from "react-icons/fa";
import pageTransition from "../utils/pageTransition";
import { ResponsiveLine } from "@nivo/line";
import { Defs } from "@nivo/core";
import moment from "moment";
var nasdaqData = require("./data/NASDAQ.json");
var nyseData = require("./data/NYSE.json");
var sp500Data = require("./data/SP500.json");

class Search extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      query: "",
      results: {},
      loading: false,
      message: "",
      filter: "NASDAQ",
      dataType: "nasdaqData",
      mobile: false,
      search: true,
      stockSymbol: "",
      stockName: "",
      currentPrice: "",
      enterpriseValue: "",
      pe: "",
      outstandingShares: "",
      eps: "",
      recommendationKey: "",
      historicData: "",
      graphData: [],
      staticData: [],
      graph: false,
      error: false,
      shareCount: 0,
      graphFilter: "5y",
    };
  }

  handleResize = (e) => {
    $(".menu").css("display", "block");
    $(".dropdown").css("flex-direction", "column");
  };

  componentDidMount = () => {
    if (window.location.href.split(window.location.host)[1] === "/stocks") {
      window.setInterval(() => {
        if (!this.state.stockName == "" && this.state.error == false) {
          this.props.fetchSingleStock(this.state.stockSymbol);
          console.log("Updating Price...");
          $(".data-list").css("opacity", "0.3");
          $(".price-loader").fadeIn("fast");
          setTimeout(() => {
            console.log("Price Updated.");
            var pe =
              this.props.activity.activity.indexes[0].apiData[0].currentPrice
                .raw /
              this.props.activity.activity.indexes[0].apiData[8].trailingEps
                .raw;
            pe = pe.toFixed(2);
            this.setState({
              currentPrice: this.props.activity.activity.indexes[0].apiData[0]
                .currentPrice.fmt,
              enterpriseValue: this.props.activity.activity.indexes[0]
                .apiData[8].enterpriseValue.fmt,
              outstandingShares: this.props.activity.activity.indexes[0]
                .apiData[8].sharesOutstanding.fmt,
              eps: this.props.activity.activity.indexes[0].apiData[8]
                .trailingEps.fmt,
              pe: pe,
              reccKey: this.props.activity.activity.indexes[0].apiData[0]
                .recommendationKey,
            });
            $(".data-list").css("opacity", "1");
            $(".price-loader").fadeOut("fast");
          }, 1000);
        }
      }, 15000);
    }

    var x = window.matchMedia("(max-width: 700px)");
    if (x.matches) {
      this.setState({ mobile: true });
    } else {
      this.setState({ mobile: false, modal: false });
    }
    $(window).resize(() => {
      this.handleResize();
    });
  };

  handleOnInputChange = (event) => {
    const query = event.target.value;
    if (!query) {
      this.setState({
        query,
        results: [],
      });
    } else {
      this.setState({ query });
    }
  };

  setFilter = (filter) => {
    let selectedData = filter;
    if (this.state.mobile == true) {
      this.slideNav();
    }
    if (selectedData == "nas") {
      this.setState({ filter: "NASDAQ", dataType: "nasdaqData" });
    } else if (selectedData == "nyse") {
      this.setState({ filter: "NYSE", dataType: "nyseData" });
    } else if (selectedData == "sp") {
      this.setState({ filter: "S&P500", dataType: "sp500Data" });
    }
  };

  renderSearchResults = () => {
    const { results } = this.state;
    if (Object.keys(results).length && results.length) {
      return (
        <div className="results-container">
          {results.map((result) => {
            return (
              <a
                key={result.id}
                href={result.previewURL}
                className="result-items"
              ></a>
            );
          })}
        </div>
      );
    }
  };

  fetchData = (sym, name, renderDataPage) => {
    $(".stock-loader").fadeIn("fast");
    this.props.fetchSingleStock(sym);
    this.renderDataPage(sym, name);
  };

  renderDataPage = (sym, name) => {
    setTimeout(() => {
      $(".stock-loader").fadeOut("fast");
      let resultsArr = this.props.activity.activity.indexes[0].apiData;
      if (
        this.props.activity.activity.isFetching == false ||
        resultsArr.some((item) => item === undefined)
      ) {
        this.setState({ error: true, search: false });
      } else {
        this.setState({
          search: false,
          stockName: name,
          stockSymbol: sym,
          error: false,
        });
        if (this.state.error == false) {
          setTimeout(() => {
            $(".data-list").css("opacity", "0.3");
            $(".graph").css("opacity", "0.3");
            $(".price-loader").fadeIn("fast");
            $(".graph-loader").fadeIn("fast");
          }, 100);
          setTimeout(() => {
            // init arrays
            var dates = this.props.activity.activity.indexes[1].result[0]
              .timestamp;

            var prices = this.props.activity.activity.indexes[1].result[0]
              .indicators.quote[0].close;

            var dailyPrices = this.props.activity.activity.indexes[2].result[0]
              .indicators.quote[0].close;
            dailyPrices = dailyPrices.slice(dailyPrices.length - 30);
            var dailyDates = this.props.activity.activity.indexes[2].result[0]
              .timestamp;
            dailyDates = dailyDates.slice(dailyDates.length - 30);
            // chop to hundredths
            for (var i = 0; i < prices.length; i++) {
              prices[i] = prices[i].toFixed(2);
            }
            for (var i = 0; i < dailyPrices.length; i++) {
              dailyPrices[i] = dailyPrices[i].toFixed(2);
            }
            // convert to string and fix dates for unix time
            var datesString = dates.map(String);
            for (var i = 0; i < datesString.length; i++) {
              datesString[i] = datesString[i] + "000";
            }

            var dailyDatesString = dailyDates.map(String);
            for (var i = 0; i < dailyDatesString.length; i++) {
              dailyDatesString[i] = dailyDatesString[i] + "000";
            }
            // convert back to int
            var datesInt = datesString.map(Number);
            var dailyDatesInt = dailyDatesString.map(Number);
            // convert to usable date format and chop off time of day
            var actualDates = datesInt.map((elem) =>
              new Date(elem).toISOString()
            );
            for (var i = 0; i < actualDates.length; i++) {
              actualDates[i] = actualDates[i].substr(0, 10);
            }

            var actualDailyDates = dailyDatesInt.map((elem) =>
              new Date(elem).toISOString()
            );
            for (var i = 0; i < actualDailyDates.length; i++) {
              actualDailyDates[i] = actualDailyDates[i].substr(0, 10);
            }

            prices = prices.map(Number);

            function buildData(time) {
              if (time == "monthly") {
                var xAxis = [];
                for (var i = 0; i < 160; i++) {
                  xAxis.push(i);
                }
                var xyData = [];
                for (var i = 0; i < prices.length; i++) {
                  xyData.push({ x: actualDates[i], y: prices[i] });
                }
                return xyData;
              } else if (time == "daily") {
                var xAxis = [];
                for (var i = 0; i < 30; i++) {
                  xAxis.push(i);
                }
                var xyData = [];
                for (var i = 0; i < dailyPrices.length; i++) {
                  xyData.push({ x: actualDailyDates[i], y: dailyPrices[i] });
                }
                return xyData;
              }
            }
            let graphData = [
              {
                id: this.state.stockSymbol,
                color: "rgb(0, 0, 0)",
                data: buildData("monthly"),
              },
            ];
            let staticData = [
              {
                id: this.state.stockSymbol,
                color: "rgb(0, 0, 0)",
                data: buildData("monthly"),
              },
            ];
            let monthlyData = [
              {
                id: this.state.stockSymbol,
                color: "rgb(0, 0, 0)",
                data: buildData("daily"),
              },
            ];

            this.setState({
              graphData: graphData,
              staticData: staticData,
              monthlyData: monthlyData,
              dailyGraph: false,
            });

            var pe =
              this.props.activity.activity.indexes[0].apiData[0].currentPrice
                .raw /
              this.props.activity.activity.indexes[0].apiData[8].trailingEps
                .raw;
            pe = pe.toFixed(2);
            this.setState({
              currentPrice: this.props.activity.activity.indexes[0].apiData[0]
                .currentPrice.fmt,
              enterpriseValue: this.props.activity.activity.indexes[0]
                .apiData[8].enterpriseValue.fmt,
              outstandingShares: this.props.activity.activity.indexes[0]
                .apiData[8].sharesOutstanding.fmt,
              eps: this.props.activity.activity.indexes[0].apiData[8]
                .trailingEps.fmt,
              pe: pe,
              reccKey: this.props.activity.activity.indexes[0].apiData[0]
                .recommendationKey,
              graph: true,
            });
            $(".data-list").css("opacity", "1");
            $(".price-loader").fadeOut("fast");
            $(".graph").css("opacity", "1");
            $(".graph-loader").fadeOut("fast");
          }, 1000);
        }
      }
    }, 2000);
  };

  renderSearch = () => {
    this.props.activity.activity.isFetching = false;
    this.setState({
      search: true,
      currentPrice: "",
      enterpriseValue: "",
      outstandingShares: "",
      eps: "",
      pe: "",
      reccKey: "",
      graphData: "",
      graph: false,
      error: false,
      stockName: "",
      stockSymbol: "",
    });
  };

  slideNav = () => {
    var x = window.matchMedia("(max-width: 700px)");
    if (x.matches) {
      if ($(".dropdown.search").hasClass("collapsed")) {
        $(".dropdown.search").stop(true, true).slideToggle();
        $(".dropdown.search").css("overflow-x", "hidden");
        $(".search-filter-arrow").css("transform", "rotate(180deg)");
        $(".search-filter-arrow").css("top", "10px");
        $(".dropdown.search").removeClass("collapsed");
        $(".dropdown.search").css("display", "flex");
      } else {
        $(".dropdown.search").addClass("collapsed");
        $(".dropdown.search").stop(true, true).slideToggle();
        $(".search-filter-arrow").css("transform", "rotate(0deg)");
        $(".search-filter-arrow").css("top", "2px");
      }
    } else {
      if ($(".dropdown.search").hasClass("collapsed")) {
        $(".dropdown.search").stop(true, true).slideToggle();
        $(".search-filter-arrow").css("transform", "rotate(180deg)");
        $(".search-filter-arrow").css("top", "7px");
        $(".dropdown.search").removeClass("collapsed");
        $(".dropdown.search").css("display", "flex");
      } else {
        $(".dropdown.search").addClass("collapsed");
        $(".dropdown.search").stop(true, true).slideToggle();
        $(".search-filter-arrow").css("transform", "rotate(0deg)");
        $(".search-filter-arrow").css("top", "-4px");
      }
    }
  };

  onChange = (e) => {
    this.setState({ [e.target.id]: e.target.value });
  };

  addShares = (sym, name, amount, current) => {
    var shareCount = Number(amount);
    var currentPrice = Number(current);
    var stock = {
      stock: [
        {
          symbol: sym,
          name: name,
          amount: shareCount,
          price: currentPrice,
        },
      ],
    };
    console.log(stock);
    let id = this.props.activity.auth.user.id;
    axios
      // .post(`http://localhost:3005/api/stocks/${id}/stock`, stock)
      .post(`https://trend-backend.herokuapp.com/api/stocks/${id}/stock`, stock)
      .then((res) => {
        this.setState({ modal: false });
        $(".shares-modal-wrapper").fadeOut("fast");
        console.log(res);
      });
  };

  showModal = () => {
    if (this.state.modal) {
      this.setState({ modal: false });
      $(".shares-modal-wrapper").fadeOut("fast");
    } else {
      this.setState({ modal: true });
      $(".shares-modal-wrapper").fadeIn("fast");
    }
  };

  setGraphFilter = (setFilter) => {
    this.setState({ graphFilter: setFilter });
    const data = [...this.state.staticData[0].data];
    const monthlyData = [...this.state.monthlyData[0].data];
    if (setFilter == "All") {
      this.state.dailyGraph = false;
      this.state.graphData[0].data = data;
    } else if (setFilter == "5Y") {
      this.state.dailyGraph = false;
      this.state.graphData[0].data = data.slice(data.length - 60);
    } else if (setFilter == "1Y") {
      this.state.dailyGraph = false;
      this.state.graphData[0].data = data.slice(data.length - 13);
    } else if (setFilter == "6M") {
      this.state.dailyGraph = false;
      this.state.graphData[0].data = data.slice(data.length - 7);
    } else if (setFilter == "1M") {
      this.state.dailyGraph = true;
      this.state.graphData[0].data = monthlyData;
    }
  };

  render() {
    const getRequiredDateFormat = (timeStamp, format = "YYYY-MM-DD") => {
      return moment(timeStamp).format(format);
    };

    $("li").on("click", function () {
      $(".timespan.current").removeClass("current");
      $(this).addClass("current");
    });

    const { query } = this.state;
    var results;
    if (this.state.filter == "NASDAQ") {
      results = nasdaqData.Companies.filter((data) => {
        if (query == "");
        else if (
          data.Symbol.toLowerCase().includes(query.toLowerCase()) ||
          data.Name.toLowerCase().includes(query.toLowerCase())
        ) {
          return data;
        }
      });
    } else if (this.state.filter == "NYSE") {
      results = nyseData.Companies.filter((data) => {
        if (query == "");
        else if (
          data.Symbol.toLowerCase().includes(query.toLowerCase()) ||
          data.Name.toLowerCase().includes(query.toLowerCase())
        ) {
          return data;
        }
      });
    } else if (this.state.filter == "S&P500") {
      results = sp500Data.Companies.filter((data) => {
        if (query == "");
        else if (
          data.Symbol.toLowerCase().includes(query.toLowerCase()) ||
          data.Name.toLowerCase().includes(query.toLowerCase())
        ) {
          return data;
        }
      });
    }

    return (
      <div className="container">
        <div className="stock-loader">
          <div className="loader">Loading...</div>
        </div>
        <PageTransition />
        <Nav />
        {this.state.search ? (
          <div className="search-wrapper">
            <h2 className="heading">Find Stocks</h2>
            <p className="desc">
              Easily search through all publicly traded stocks
            </p>
            <div className="search-cont">
              <div className="search-bar">
                <label className="search-label" htmlFor="search-input">
                  <input
                    type="text"
                    name="query"
                    value={query}
                    id="search-input"
                    placeholder="Search..."
                    onChange={this.handleOnInputChange}
                    autoComplete="off"
                  />
                  <FaSearch className="search-icon" />
                </label>
                <div
                  className="filter-wrapper"
                  onClick={() => (this.state.mobile ? this.slideNav() : null)}
                  onMouseEnter={() =>
                    this.state.mobile ? null : this.slideNav()
                  }
                  onMouseLeave={() =>
                    this.state.mobile ? null : this.slideNav()
                  }
                >
                  <div className="dropdown-toggle">
                    <div className="current-filter-wrapper">
                      <p className="current-filter">{this.state.filter}</p>
                      <FaSortDown className="search-filter-arrow" />
                    </div>
                  </div>
                  <div className="dropdown search collapsed">
                    <span
                      className="filter"
                      onClick={() => {
                        this.setFilter("nas");
                      }}
                    >
                      NASDAQ
                    </span>
                    <hr className="filter-line one" />
                    <span
                      className="filter"
                      onClick={() => {
                        this.setFilter("nyse");
                      }}
                    >
                      NYSE
                    </span>
                    <hr className="filter-line two" />
                    <span
                      className="filter"
                      onClick={() => {
                        this.setFilter("sp");
                      }}
                    >
                      S&P500
                    </span>
                  </div>
                </div>
              </div>
              <div className="results-wrapper">
                <div className="search-results">
                  <ul>
                    {results.slice(0, 10).map((data) => {
                      return (
                        <li
                          key={data.Symbol}
                          className="result"
                          onClick={() => this.fetchData(data.Symbol, data.Name)}
                        >
                          <span className="symbol">{data.Symbol}</span>
                          <span className="name">{data.Name}</span>
                        </li>
                      );
                    })}
                  </ul>
                </div>
              </div>
            </div>
          </div>
        ) : (
          <div className="stock-wrapper">
            {this.state.error ? (
              <div className="error-page">
                <div className="error-cont">
                  <FaExclamationTriangle className="error" />
                  <div className="error-text">
                    <h2>Oops! Stock data not found.</h2>
                    <p>
                      The company you were searching for probably does not exist
                      or is not publicly traded.
                    </p>
                  </div>
                </div>
                <div className="search-button">
                  <button
                    onClick={() => {
                      this.renderSearch();
                    }}
                  >
                    Search
                  </button>
                </div>
              </div>
            ) : (
              <div className="stock-page-cont">
                <div className="search-button">
                  <button
                    onClick={() => {
                      this.renderSearch();
                    }}
                  >
                    Search
                  </button>
                </div>

                <div className="shares-modal-wrapper">
                  <div className="shares-modal">
                    <FaTimes
                      className="exit"
                      onClick={() => {
                        this.showModal();
                      }}
                    />
                    <div className="title-wrapper">
                      <h3 className="title">Add Owned Shares</h3>
                      <p className="share-sym">
                        You are currently adding shares of{" "}
                        <span className="symbol">{this.state.stockSymbol}</span>
                      </p>
                      <p className="notice">
                        To edit share amount of an existing account stock,
                        please visit account settings
                      </p>
                    </div>
                    <div className="shares-form">
                      <label>Shares</label>
                      <input
                        type="shares"
                        onChange={this.onChange}
                        value={this.state.shareCount}
                        id="shareCount"
                      ></input>
                      <button
                        className="submit-shares"
                        onClick={() => {
                          this.addShares(
                            this.state.stockSymbol,
                            this.state.stockName,
                            this.state.shareCount,
                            this.state.currentPrice
                          );
                        }}
                      >
                        Add Shares
                      </button>
                    </div>
                  </div>
                </div>
                <div className="info">
                  <div className="title-wrapper">
                    <h2 className="stock">{this.state.stockName}</h2>
                    <div className="share-btn-wrapper">
                      <button
                        className="share-btn"
                        onClick={() => {
                          this.showModal();
                        }}
                      >
                        Click here to add owned shares
                      </button>
                    </div>
                    <h4 className="stock-symbol">{this.state.stockSymbol}</h4>
                  </div>
                  <hr className="divide-line" />
                  <div className="data-wrapper">
                    <div className="graph-wrapper">
                      <div className="graph-loader">
                        <FaHammer className="hammer" />
                        <p className="loading-text">Building graph...</p>
                      </div>
                      <ul className="graph-filter-wrapper">
                        <li
                          className="timespan ten current"
                          onClick={() => {
                            this.setGraphFilter("All");
                          }}
                        >
                          All
                        </li>
                        <li
                          className="timespan five"
                          onClick={() => {
                            this.setGraphFilter("5Y");
                          }}
                        >
                          5Y
                        </li>
                        <li
                          className="timespan one"
                          onClick={() => {
                            this.setGraphFilter("1Y");
                          }}
                        >
                          1Y
                        </li>
                        <li
                          className="timespan six"
                          onClick={() => {
                            this.setGraphFilter("6M");
                          }}
                        >
                          6M
                        </li>
                        <li
                          className="timespan oneM"
                          onClick={() => {
                            this.setGraphFilter("1M");
                          }}
                        >
                          1M
                        </li>
                        <hr />
                      </ul>
                      <div className="graph">
                        {this.state.graph ? (
                          <ResponsiveLine
                            key={""}
                            data={this.state.graphData}
                            margin={{
                              top: 35,
                              right: 45,
                              bottom: 50,
                              left: 80,
                            }}
                            xScale={{
                              type: "linear",
                              min: "auto",
                              max: "auto",
                              stacked: true,
                              reverse: false,
                            }}
                            enableSlices="x"
                            sliceTooltip={({ slice }) => {
                              const date = slice.points[0].data.xFormatted;
                              return (
                                <div
                                  style={{
                                    color: "lightgrey",
                                  }}
                                >
                                  {this.state.dailyGraph ? (
                                    <strong
                                      style={{ color: "#7A216E" }}
                                      key={date}
                                    >
                                      {`${getRequiredDateFormat(
                                        date,
                                        "MMMM DD"
                                      )}`}{" "}
                                    </strong>
                                  ) : (
                                    <strong
                                      style={{ color: "#7A216E" }}
                                      key={date}
                                    >
                                      {`${getRequiredDateFormat(
                                        date,
                                        "MMMM YYYY"
                                      )}`}{" "}
                                    </strong>
                                  )}
                                  -{" "}
                                  {slice.points.map((point) => (
                                    <strong
                                      style={{
                                        color: "#C58C55",
                                        fontWeight: "bolder",
                                      }}
                                      key={point.data.yFormatted}
                                    >
                                      {`${point.data.yFormatted}$`}
                                    </strong>
                                  ))}
                                </div>
                              );
                            }}
                            yScale={{
                              type: "linear",
                              min: "auto",
                              max: "auto",
                              stacked: true,
                              reverse: false,
                            }}
                            axisTop={null}
                            axisRight={null}
                            axisBottom={null}
                            axisLeft={{
                              orient: "left",
                              tickSize: 5,
                              tickPadding: 5,
                              tickRotation: 0,
                              legend: "PRICE",
                              legendOffset: -65,
                              legendPosition: "middle",
                              format: (value) =>
                                `${Number(value).toLocaleString("usd", {
                                  minimumFractionDigits: 0,
                                })}.00$`,
                            }}
                            xScale={{
                              type: "time",
                              format: "%Y-%m-%d",
                              useUTC: false,
                              precision: "day",
                            }}
                            xFormat="time:%Y-%m-%d"
                            enableGridX={false}
                            enableGridY={false}
                            enablePoints={false}
                            lineWidth={2}
                            colors={{ scheme: "nivo" }}
                            pointColor={{ theme: "background" }}
                            pointBorderWidth={2}
                            pointBorderColor={{ from: "serieColor" }}
                            pointLabel="y"
                            pointLabelYOffset={0}
                          />
                        ) : null}
                      </div>
                    </div>

                    <div className="current-info">
                      <div className="price-loader">
                        <FaDollarSign className="dollar" />
                        <p className="loading-text">Updating Data...</p>
                      </div>
                      <p className="data-title">Real-Time Financial Data</p>
                      <ul className="data-list">
                        <li className="current price">
                          Current Price
                          <span className="data">
                            $ {this.state.currentPrice}
                          </span>
                        </li>
                        <li className="current temp">
                          Enterprise Value
                          <span className="data">
                            $ {this.state.enterpriseValue}
                          </span>
                        </li>
                        <li className="current temp">
                          Outstanding Shares
                          <span className="data">
                            {this.state.outstandingShares}
                          </span>
                        </li>
                        <li className="current temp">
                          Earnings Per Share
                          <span className="data">$ {this.state.eps}</span>
                        </li>
                        <li className="current temp">
                          Price-to-Earnings Ratio
                          <span className="data">{this.state.pe}</span>
                        </li>
                        <li className="current reccomendation">
                          reccomendation
                          <span className="data">{this.state.reccKey}</span>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
        )}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    activity: state,
    error: state.error,
  };
};

export default connect(mapStateToProps, { fetchSingleStock })(Search);
